(function () {
  'use strict';

  // Legacy classic Product Options: the app renders plain <select> dropdowns
  // with no per-value imagery, so — to match the modern generation, which
  // shows the selected value's photo beneath each option — this module injects
  // a thumbnail below each legacy option and keeps it in sync with the
  // selection. The image source is the app's own config global (the same place
  // apo-image-swap.js reads overlay images from); the reader is duplicated here
  // rather than shared so the live-on-bont.com modern engine is never touched.
  // Loaded only on legacy pages (from snippets/apo-legacy-objects.liquid).

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var MEDIA_CLASS = 'apo-legacy-option-media';
  var POLL_INTERVAL = 400;
  var MAX_ATTEMPTS = 20;

  /** Resolve a value's configured image URL from the app config, or '' . */
  function valueImageSrc(valueId) {
    if (!valueId) return '';
    try {
      var options = window.mwProductOptions.Module.config.options;
      for (var key in options) {
        var values = options[key] && options[key].values;
        var value = values && values[valueId];
        if (value) {
          return (value.images && value.images[0] && value.images[0].url) || '';
        }
      }
    } catch (e) {}
    return '';
  }

  /** data-value-id of a select's currently selected <option>, or '' . */
  function selectedValueId(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? (opt.getAttribute('data-value-id') || '') : '';
  }

  /** Create/update/remove the thumbnail for one .mw-option block (idempotent). */
  function renderFor(optionBlock) {
    var select = optionBlock.querySelector('select');
    if (!select) return;

    var src = valueImageSrc(selectedValueId(select));
    var media = optionBlock.querySelector('.' + MEDIA_CLASS);

    if (!src) {
      if (media && media.parentNode) media.parentNode.removeChild(media);
      return;
    }

    if (!media) {
      media = document.createElement('div');
      media.className = MEDIA_CLASS;
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      img.loading = 'lazy';
      media.appendChild(img);
      optionBlock.appendChild(media);
    }

    var image = media.querySelector('img');
    // Idempotent: only touch the DOM when the source actually changes, so the
    // MutationObserver below does not feed back into an endless render loop.
    if (image && image.getAttribute('src') !== src) image.setAttribute('src', src);
  }

  function renderAll() {
    var blocks = document.querySelectorAll('.mw-options-container .mw-option');
    for (var i = 0; i < blocks.length; i++) renderFor(blocks[i]);
  }

  function start(container) {
    // Update the thumbnail for the option the shopper just changed.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.mw-options-container select')) {
        var block = t.closest('.mw-option');
        if (block) renderFor(block);
      }
    });

    // The app re-renders options on its conditional logic; re-sync (debounced).
    if (typeof MutationObserver !== 'undefined') {
      var timer;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(renderAll, 60);
      });
      observer.observe(container, { childList: true, subtree: true, attributes: true });
    }

    // Render now, and keep trying until the app config is available.
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      renderAll();
      if (window.mwProductOptions || attempts >= 10) clearInterval(poll);
    }, POLL_INTERVAL);
  }

  function init() {
    // The theme's legacy mount is in the initial DOM on APO product pages; bail
    // early everywhere else (this file loads site-wide on legacy stores).
    if (!document.querySelector('.mw-product-options')) return;

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var container = document.querySelector('.mw-options-container');
      if (container) {
        clearInterval(poll);
        start(container);
      } else if (attempts >= MAX_ATTEMPTS) {
        clearInterval(poll);
      }
    }, POLL_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
